import axios from "axios";
import gameknight from "../../router/gameknight";
import country_list from "../../locales/country_list.json";
const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();
const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("lang_Gkn");

if(language =='ms'){
    brwlang ='malay';
  }else if(language =='ar'){
    brwlang ='arabic';
  }else if(language =='el'){
    brwlang ='greek';
  }else if(language =='bg' || parts[0] =='bg'){
    brwlang ='bulgarian';
  }else if(language =='no' || parts[0] =='no'){
    brwlang ='norwegian';
  }else if(language =='id'){
    brwlang ='indonesian';
  }else if(language =='th'){
    brwlang ='thai';
  }else if(language =='cs' || parts[0] =='cz'){
    brwlang ='czech';
  }else if(language =='en'){
    brwlang ='english';
  }

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = ''

if (type == true) {
    gcid = parts[1]
} else {
    gcid = ''
}

const state = {
    live: `http://cook.grabmobi.com`,
    local: `http://[::1]/PuretechGlobalContentPortal`,
    proxyurl: `http://api.allorigins.win/get?url=`,
    //auth
    langButton_Gkn: ``,
    country_Gkn: parts[0],
    // lang_Gkn: localStorage.getItem("lang_Gkn"),
    lang_Gkn: brwlang,
    authentication_Gkn: "",
    Icon_hotpick_Gkn: require(`../../assets/gameknight/imgs/other/Hot Picks.svg`),
    Icon_popular_Gkn: require(`../../assets/gameknight/imgs/other/Populars.svg`),
    //notification.vue
    notification_Gkn: {},
    HotPicksPage_Gkn: {},
    PopularPage_Gkn: {},
    host_Gkn: host,
    gcid_Gkn: gcid,
    renew_date_Gkn: '',
    subscription_date_Gkn: '',
    msisdn_Gkn: '',
    country_name_Gkn: '',
    gateway_Gkn: '',
    is_unsub: '0',
    subcategory_id_Gkn: ''
};

const getters = {
    gcid_Gkn: state => state.gcid_Gkn,
    IconHotPick_Gkn: state => state.Icon_hotpick_Gkn,
    IconPopular_Gkn: state => state.Icon_popular_Gkn,
    notification_Gkn: state => state.notification_Gkn,
    authentication_Gkn: state => state.authentication_Gkn,
    HotPicksPage_Gkn: state => state.HotPicksPage_Gkn,
    PopularPage_Gkn: state => state.PopularPage_Gkn,
    langButton_Gkn: state => state.langButton_Gkn,
    lang_Gkn: state => state.lang_Gkn,
    country_Gkn: state => state.country_Gkn,
    host_Gkn: state => state.host_Gkn,
    renew_date_Gkn: state => state.renew_date_Gkn,
    subscription_date_Gkn: state => state.subscription_date_Gkn,
    msisdn_Gkn: state => state.msisdn_Gkn,
    country_name_Gkn: state => state.country_name_Gkn,
    gateway_Gkn: state => state.gateway_Gkn,
    is_unsub_Gkn: state => state.is_unsub,
    subcategory_id_Gkn: state => state.subcategory_id_Gkn
};

const actions = {
    async fetchLanguage_Gkn({ commit }, lang) {
        for (let [key, value] of Object.entries(country_list)) {
            if(lang == value.language){
                lang = value.language
            }else{
                //english
                lang = lang
            }
        }
        
        commit("setLanguage", lang);
    },
    async fetchLanguageButton_Gkn({commit}, country) {
        for (let [key, value] of Object.entries(country_list)) {
            if(country == key){
              let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
              <img lang="${value.language}" src="${value.flag_rec}" />
              <span lang="${value.language}">${value.button_text}</span>
              </button>`
      
              commit("setButton", button);
            }
        }
    },
    async fetchHotPicksGame_Gkn({ commit }, file) {
        let data = file[0]

        let limit = 0;
    
        if (file[1] != undefined) {
            limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
        } else {
            //default
            limit = 200;
        }
    
        let response = []

        if(data == undefined){
            response = await axios.get(
                `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=${limit}&offset=0&domain=${host}`
            );
        }else{
            response = await axios.get(
                `${state.live}/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=${data}&limit=${limit}&offset=0&domain=${host}`
            );
        }
        
        response.data.data.sort((a,b) =>
            a.cont_name_english.localeCompare(b.cont_name_english)
        )

        commit("setPageHotPicks", response.data.data);
    },
    async fetchPopularGame_Gkn({ commit }, e) {
        let limit = 0;

        if (e != undefined) {
            limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
        } else {
            //default
            limit = 200;
        }

        let url = `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=${limit}&offset=0&domain=${host}`

        let response = await axios.get(url);

        let data = response.data.data
        
        data.sort(function(a, b) {
            //to sort random
            return b.rating - a.rating;
        });
        commit("setPagePopular", data);
    },
    async getDomain_Gkn({ commit }, host){
        let response = await axios.get(`${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`);

        let dom= response.data.data
        dom = dom.filter(item =>{
            return item.domain == host;
        })

        let domain = ""

        if(dom != ""){
            domain = dom[0].is_unsub;

            if(dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id)
        }else{
            domain = '0'
        }
        
        commit("setUnsubButton", domain);
        
    },
    async fetchTokenID_Gkn({ commit, dispatch }, id) {
        let auth = "";
        let check = "";
        let token = localStorage.getItem("userTokenID_Gkn");
        let userProfile = localStorage.getItem("userProfile_Gkn");
        
        let str = window.location.pathname;
        let path = str.split("/");
        path.pop();
        path = path.join('/');

        if(path == ''){
            path = '/home';
        }

        if (token != null) {
            //checking if have token
            auth = token;
        } else {
            //checking if have param id
            auth = id;
        }

        if (auth != undefined) {
            //to check if token has numbers and letters
            // check = dispatch("checkTokenID_Gkn", auth);
            auth = auth.toLowerCase();
            var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
            if (auth.match(letterNumber)) {
                check = true
            } else {
                check = false
            }
        } else {
            gameknight.push({ name: "Login" }).catch(err => {});
        }

        if (check == true) {
            //if check is true
            let data = {
                code: auth,
                verbose: "1"
            };

            if (token != null) {
                if(data.code == 'gkn80'){
                    localStorage.setItem("userTokenID_Gkn", data.code);
                    commit("setAuth", "guest");
                }else{
                    localStorage.setItem("userTokenID_Gkn", data.code);
                    commit("setUserProfile", JSON.parse(userProfile));
                    commit("setAuth", "loggedin");
                }
            // EventBus.$emit("logged-in", "loggedin");
            } else {
                if(data.code == 'gkn80'){
                    localStorage.setItem("userTokenID_Gkn", data.code);
                    commit("setAuth", "guest");
                    gameknight.push({ path: path }).catch(err => {});
                } else{
                    let responses = await axios.post(
                        `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
                    );
                    var response = JSON.parse(responses.data.contents);
                    if (response.status == "active") {
                        localStorage.setItem("userTokenID_Gkn", data.code);
                        localStorage.setItem("userProfile_Gkn", responses.data.contents)
                        commit("setUserProfile", response);
                        commit("setAuth", "loggedin");
                        gameknight.push({ path: path }).catch(err => {});
                        // location.reload();
                    } else if (response.status == "inactive") {
                        if(data.code != undefined){
                            alert(response.status.toUpperCase())
                        }
                        gameknight.push({ name: "Login" }).catch(err => {});
                    }
                }
                
            }
        } else {
            //if check is false
            gameknight.push({ name: "Login" }).catch(err => {});
        }
    },
    async checkTokenID_Gkn({ commit }, auth) {
        var letterNumber = /^[0-9a-zA-Z]+$/;
        if (auth.match(letterNumber)) {
            return true;
        } else {
            return false;
        }
    },
    async subscribeContent_Gkn({ commit }, file) {
        let token = localStorage.getItem("userTokenID_Gkn");
        let lang = localStorage.getItem("lang_Gkn");
        let alert_pop = "";

        let alert_lang = require(`../../locales/gameknight/${lang}.json`);
        alert_pop = alert_lang.not_subs;
        if(state.authentication_Gkn == 'guest'){
            commit("setAuth", "");
            localStorage.removeItem("userTokenID_Gkn");
            gameknight.push({ name: "Login" }).catch(err => {});
        }else{
            if (token != null) {
                if (file[1] != 'application/x-zip-compressed') {
                    axios.post(`${state.live}/api/newcontents_statistic`, {
                        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                        country: state.country_Gkn,
                        product: 'gameknight',
                        content_id: file[2],
                        type: "download"
                    })
                    window.location.href = file[0];
                    // window.open(file[0], "download");
                } else {
                    axios.post(`${state.live}/api/newcontents_statistic`, {
                        token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
                        country: state.country_Gkn,
                        product: 'gameknight',
                        content_id: file[2],
                        type: "play"
                    })

                    window.open(file[0], "_blank");
                }
            } else {
                alert(alert_pop);
    
                setTimeout(() => {
                    gameknight.push({ name: "Login" }).catch(err => {});
                }, 1000);
            }
        }
        
    },
    async login_Gkn({ commit }, loginAuth) {
        commit("setAuth", loginAuth);
    },
    async fetchGameNotification_Gkn({ commit }) {
        let notify =[]
        let date = currentDate.getUTCDate();
        let w = week % 2;

        if(w != 0){
            date = date + 10
        }

        let url = `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=10&offset=${date}&domain=${host}`;

        let res = await axios.get(url);

        let data = res.data.data.slice(0,5);
        
        let noti = data.map((noti) =>{
            let sub_trans = JSON.parse(noti.subcategory_translate)
            // console.log(noti.created_time)
            let trans_len = Object.keys(sub_trans).length
            let trans_arr = Object.keys(sub_trans)
            
            noti.titleSub_english = noti.subcategory
            if(sub_trans != null || sub_icon != null){
                for(let i = 0; i<trans_len; i++){
                    noti['titleSub_'+trans_arr[i]] = sub_trans[trans_arr[i]].title
                }
            }

            return noti;
        })

        if(w == 0){
            //name ascending
            noti.sort((a, b) => a.cont_name_english.localeCompare(b.cont_name_english))
        }else{
            //name descending
            noti.sort((a, b) => b.cont_name_english.localeCompare(a.cont_name_english))
        }
      
        notify = noti.slice(0,5);

        commit("setNotification", notify);
    },
    async logout_Gkn({commit}, is_unsub){
        if(is_unsub != '0'){
            let token = localStorage.getItem("userTokenID_Gkn")
            let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_name_Gkn}/${state.gateway_Gkn}/unsub.php?code=${token}&msisdn=${state.msisdn_Gkn}`));
            removeStorage()
            console.log(response);
            var response = JSON.parse(responses.data.contents);
            if(responses.data.contents == 'success'|| response.status =='success'){
              location.reload();
            }
            setTimeout(() => {
              location.reload();
            }, 0);
          }else{
            removeStorage();
          }
      
        function removeStorage(){
            localStorage.removeItem("userProfile_Gkn");
            localStorage.removeItem("userTokenID_Gkn");
            localStorage.removeItem("logged-in");
        } 

    },
    async getSubCategory_Gkn({commit}, subcategory){
        commit('setSubcategory', subcategory)
    }
};

const mutations = {
    setNotification: (state, response) => (state.notification_Gkn = response),
    setAuth: (state, response) => (state.authentication_Gkn = response),
    setPageHotPicks: (state, response) => (state.HotPicksPage_Gkn = response),
    setPagePopular: (state, response) => (state.PopularPage_Gkn = response),
    setButton: (state, response) => (state.langButton_Gkn = response),
    setLanguage: (state, response) => (state.lang_Gkn = response),
    setUserProfile: (state, response) => (
        state.renew_date_Gkn = response.next_renew_date,
        state.subscription_date_Gkn = response.subscription_date,
        state.msisdn_Gkn = response.msisdn,
        state.country_name_Gkn = response.country_code,
        state.gateway_Gkn = response.gateway_code
    ),
    setGatewayID: (state, response) =>(
        state.gcid_Gkn = response
    ),
    setUnsubButton: (state, response) => (
        state.is_unsub = response
    ),
    setSubcategory: (state, response) => (
        state.subcategory_id_Gkn = response
    )
};

export default {
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/gameknight-store.js